import React from "react";

// Número del pallet, marcando los que reutilizan el número de un pallet que
// bodega rechazó, porque ese número aparece más de una vez en los listados
export const NumeroPallet = ({ pallet }) => {
    return (
        <React.Fragment>
            {pallet.numero}

            {pallet.es_numero_reutilizado && (
                <small className="d-block text-muted">reutilizado</small>
            )}
        </React.Fragment>
    );
};
